import * as React from 'react'
import { ChevronDown } from 'lucide-react'

import { cn } from '@shared/ui/lib/utils'
import './select.css'

export interface SelectProps extends React.ComponentPropsWithoutRef<'select'> {
  readonly fullWidth?: boolean
  readonly wrapperClassName?: string
}

const Select = React.forwardRef<HTMLSelectElement, SelectProps>(function Select(
  {
    children,
    className,
    fullWidth = true,
    wrapperClassName,
    ...props
  },
  ref,
) {
  return (
    <div
      className={cn('relative', fullWidth ? 'w-full' : 'w-auto', wrapperClassName)}
      data-slot="select-wrapper"
    >
      <select
        className={cn(
          'min-h-11 appearance-none rounded-md border py-2.5 pl-3.5 pr-10 text-sm outline-none transition-[background-color,border-color,box-shadow,color] duration-150',
          fullWidth ? 'w-full' : 'w-auto',
          className,
        )}
        data-slot="select"
        ref={ref}
        {...props}
      >
        {children}
      </select>
      <ChevronDown
        aria-hidden="true"
        className="pointer-events-none absolute right-3 top-1/2 size-4 -translate-y-1/2 text-[var(--lms-color-ink-muted)]"
      />
    </div>
  )
})

export { Select }
